module.exports = __webpack_public_path__ + "static/media/Node.js.d5e1cd8c.svg";